/* __next_internal_client_entry_do_not_use__ CollectionTileViewImpressionProvider auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { trackCoreCollectionsCollectionTileView } from "@faire/web-api--source/events/coreCollections/view/collectionTile";
import React, { useCallback, useRef, useState } from "react";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { IntersectionObserverProvider } from "@faire/retailer/hooks/ProductTileImpression/__internal__/ProductTileViewImpressionContext";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { UnmountProductTileProvider } from "@faire/retailer/hooks/ProductTileImpression/__internal__/UnmountProductTileContext";
import { useVisibilityChangeEvent } from "@faire/retailer/hooks/useVisibilityChangeEvent";
import { getIsRobot } from "@faire/retailer/serialized-data/getIsRobot";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductTileViewImpressionUpperThresholdProvider } from "../ProductTileImpression/__internal__/ViewportUpperThreshold";
export var CollectionTileViewImpressionProvider = function(param) {
    var children = param.children, contextToken = param.contextToken, requestId = param.requestId, screenContext = param.screenContext, containerContext = param.containerContext;
    var _useState = _sliced_to_array(useState(0), 2), viewportThresholdHeightFromTop = _useState[0], setViewportThresholdHeightFromTop = _useState[1];
    var rootMargin = "".concat(-viewportThresholdHeightFromTop, "px 0px 0px 0px");
    var dwellTimerMapRef = useRef({});
    var handleProductTileUnmount = useCallback(function(collectionToken) {
        reportDwellTimerForCollectionTile(collectionToken, contextToken !== null && contextToken !== void 0 ? contextToken : "", requestId !== null && requestId !== void 0 ? requestId : "", dwellTimerMapRef, screenContext !== null && screenContext !== void 0 ? screenContext : "", containerContext !== null && containerContext !== void 0 ? containerContext : "");
    }, [
        containerContext,
        contextToken,
        requestId,
        screenContext
    ]);
    useVisibilityChangeEvent(function(visibilityState) {
        if (visibilityState === "hidden") {
            var collectionTokens = Object.keys(dwellTimerMapRef.current);
            collectionTokens.forEach(function(collectionToken) {
                reportDwellTimerForCollectionTile(collectionToken, contextToken !== null && contextToken !== void 0 ? contextToken : "", requestId !== null && requestId !== void 0 ? requestId : "", dwellTimerMapRef, screenContext !== null && screenContext !== void 0 ? screenContext : "", containerContext !== null && containerContext !== void 0 ? containerContext : "");
            });
        }
    });
    var handleIntersectionObserverCallback = useCallback(function(entries) {
        entries.forEach(function(entry) {
            var _entry_target_getAttribute;
            var collectionToken = (_entry_target_getAttribute = entry.target.getAttribute("data-collection-token")) !== null && _entry_target_getAttribute !== void 0 ? _entry_target_getAttribute : "";
            var _entry_target_getAttribute1;
            var brandPromoToken = (_entry_target_getAttribute1 = entry.target.getAttribute("data-brand-promo-token")) !== null && _entry_target_getAttribute1 !== void 0 ? _entry_target_getAttribute1 : "";
            if (entry.isIntersecting && !dwellTimerMapRef.current[collectionToken]) {
                dwellTimerMapRef.current[collectionToken] = {
                    start: Date.now(),
                    maxThreshold: entry.intersectionRatio,
                    brandPromoToken: brandPromoToken
                };
            } else if (!entry.isIntersecting && dwellTimerMapRef.current[collectionToken]) {
                reportDwellTimerForCollectionTile(collectionToken, contextToken !== null && contextToken !== void 0 ? contextToken : "", requestId !== null && requestId !== void 0 ? requestId : "", dwellTimerMapRef, screenContext !== null && screenContext !== void 0 ? screenContext : "", containerContext !== null && containerContext !== void 0 ? containerContext : "");
            } else if (entry.isIntersecting && dwellTimerMapRef.current[collectionToken]) {
                var _dwellTimerMapRef_current_collectionToken;
                var _dwellTimerMapRef_current_collectionToken_maxThreshold;
                if (((_dwellTimerMapRef_current_collectionToken_maxThreshold = (_dwellTimerMapRef_current_collectionToken = dwellTimerMapRef.current[collectionToken]) === null || _dwellTimerMapRef_current_collectionToken === void 0 ? void 0 : _dwellTimerMapRef_current_collectionToken.maxThreshold) !== null && _dwellTimerMapRef_current_collectionToken_maxThreshold !== void 0 ? _dwellTimerMapRef_current_collectionToken_maxThreshold : 0) < entry.intersectionRatio) {
                    dwellTimerMapRef.current[collectionToken].maxThreshold = entry.intersectionRatio;
                }
            }
        });
    }, [
        containerContext,
        contextToken,
        requestId,
        screenContext
    ]);
    if (getIsRobot()) {
        return children;
    }
    return /*#__PURE__*/ _jsx(UnmountProductTileProvider, {
        onUnmount: handleProductTileUnmount,
        children: /*#__PURE__*/ _jsx(ProductTileViewImpressionUpperThresholdProvider, {
            heightFromTop: viewportThresholdHeightFromTop,
            setHeightFromTop: setViewportThresholdHeightFromTop,
            children: /*#__PURE__*/ _jsx(IntersectionObserverProvider, {
                callback: handleIntersectionObserverCallback,
                options: {
                    threshold: TWO_PERCENT_THRESHOLD,
                    rootMargin: rootMargin
                },
                children: children
            })
        })
    });
};
var reportDwellTimerForCollectionTile = function(collectionToken, contextToken, requestId, dwellTimerMapRef, screenContext, containerContext) {
    if (dwellTimerMapRef.current[collectionToken]) {
        var _dwellTimerMapRef_current_collectionToken = dwellTimerMapRef.current[collectionToken], maxThreshold = _dwellTimerMapRef_current_collectionToken.maxThreshold, brandPromoToken = _dwellTimerMapRef_current_collectionToken.brandPromoToken;
        var _maxThreshold_toString;
        trackCoreCollectionsCollectionTileView(contextToken, collectionToken, requestId !== null && requestId !== void 0 ? requestId : "", screenContext !== null && screenContext !== void 0 ? screenContext : "", containerContext !== null && containerContext !== void 0 ? containerContext : "", (_maxThreshold_toString = maxThreshold.toString()) !== null && _maxThreshold_toString !== void 0 ? _maxThreshold_toString : "", brandPromoToken !== null && brandPromoToken !== void 0 ? brandPromoToken : "");
        delete dwellTimerMapRef.current[collectionToken];
    }
};
var TWO_PERCENT_THRESHOLD = new Array(51).fill(0).map(function(_, index) {
    return index * 2;
})// this ensures no 0.15000000001 values
.map(function(percent) {
    return percent / 100;
});
